import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  ListItemSecondaryAction,
  Paper,
  withStyles,
  Chip,
  ListItemIcon,
} from '@material-ui/core'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Typography from '@material-ui/core/Typography'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import InfoIcon from '@material-ui/icons/Info'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import cn from 'classnames'
import React, { useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import compose from 'recompose/compose'
import uiActionCreators from '../../State/Store/UI/UI.actions'
import helpers from '../../Support/Text'
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support'
import Spinner from '../Spinner/Spinner.component'
import UsersListPropTypes from './UsersList.component.props'
import usersListStyles from './UsersList.component.styles'
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer'
import ResendConfirmModal from './parts/ResendConfirmModal'
import { UserAccount, UserAccountUserType } from 'types/UserProfile'
import hitGTM from 'State/Store/UI/Actions/GTM.action'
import { UI_RESEND_INVITATION_ACCOUNT_PAGE_RESEND_INVITATION_BTN, UI_ACCOUNT_PAGE_PEOPLE_VIEW_ALL_FILTER, UI_ACCOUNT_PAGE_PEOPLE_SUPER_USERS_FILTER, UI_ACCOUNT_PAGE_STANDARD_USERS_FILTER, UI_ACCOUNT_PAGE_PENDING_INVITATION_FILTER } from 'State/Store/UI/UI.types'
import SendIcon from '@material-ui/icons/Send'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import DeleteIcon from '@material-ui/icons/Delete'
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline'
import userProfileCurrentSelector from 'State/Store/UserProfile/Selectors/UserProfileCurrent.selector'

enum Tab {
  All,
  SuperUser,
  StandardUser,
  Pending,
}

interface Props {
  accountId: any,
  accountName: any,
  classes: any,
  users: UserAccount[],
  onUserTypeUpdate: any,
}
export const UsersListComponent = (props: Props) => {
  const {
    accountId,
    accountName,
    classes,
    users: originUsers,
    onUserTypeUpdate,
  } = props
  // Person tiles will be sorted alphabetically by their first name, email as fallback
  // People that do not have a name appear at the end, unsorted
  function sortFunc(a: UserAccount, b: UserAccount) {
    if (a.firstName === null && b.firstName === null) {
      return a.email > b.email ? 1 : -1
    }
    if (a.firstName === null) {
      return a.email > b.email ? 1 : -1
    }
    if (a.firstName === b.firstName) {
      return a.email > b.email ? 1 : -1
    }
    return a.firstName > b.firstName ? 1 : -1
  }
  const [ anchorEl, setAnchorEl ] = useState<any>(null)
  const [ selectedUser, setSelectedUser ] = useState<any>()
  const [ showStandardUserInfo, setshowStandardUserInfo ] = useState(false)
  const [ showSuperUserInfo, setshowSuperUserInfo ] = useState(false)
  const [ resendOpen, setResendOpen ] = useState(false)
  const [ resendUserAccount, setResendUserAccount ] = useState<null | UserAccount>(null)
  const dispatch = useDispatch()
  const [ tab, setTab ] = useState<Tab>(Tab.All)
  const userProfile = useSelector(userProfileCurrentSelector)

  const handleClick = (event: any, selectedUser: any) => {
    setAnchorEl(event.currentTarget)
    setSelectedUser(selectedUser)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setSelectedUser(null)
  }

  const closeInfoDialog = () => {
    setshowStandardUserInfo(false)
    setshowSuperUserInfo(false)
  }

  const userInfoDialog = (
    <Dialog aria-labelledby="form-dialog-title" fullWidth onClose={closeInfoDialog} open={showStandardUserInfo || showSuperUserInfo || false}>
      <DialogTitle id="form-dialog-title">{showStandardUserInfo ? `Standard ` : `Super`} User</DialogTitle>
      <DialogContent>
        {showStandardUserInfo ? (
          <Typography>Standard Users have the permission on this account to manage orders and deliveries.</Typography>
        ) : (
          <Typography>Super User has the permission on this account to manage (add and/or remove) users and manage orders and deliveries</Typography>
        )}
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button color="primary" onClick={closeInfoDialog}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
  function renderTabs() {
    return (
      <div className={classes.tabWrapper}>
        <Button
          className={cn(classes.button)}
          size='small'
          color={tab === Tab.All ? 'primary' : 'default'}
          onClick={() => {
            setTab(Tab.All)
            dispatch(hitGTM(UI_ACCOUNT_PAGE_PEOPLE_VIEW_ALL_FILTER))
          }}
        >
          {`View all (${filteredList(originUsers, Tab.All).length})`}
        </Button>
        <Button
          className={cn(classes.button)}
          size='small'
          color={tab === Tab.SuperUser ? 'primary' : 'default'}
          onClick={() => {
            setTab(Tab.SuperUser)
            dispatch(hitGTM(UI_ACCOUNT_PAGE_PEOPLE_SUPER_USERS_FILTER))
          }}
        >
          {`Super Users (${filteredList(originUsers, Tab.SuperUser).length})`}
        </Button>
        <Button
          className={cn(classes.button)}
          size='small'
          color={tab === Tab.StandardUser ? 'primary' : 'default'}
          onClick={() => {
            setTab(Tab.StandardUser)
            dispatch(hitGTM(UI_ACCOUNT_PAGE_STANDARD_USERS_FILTER))
          }}
        >
          {`Standard Users (${filteredList(originUsers, Tab.StandardUser).length})`}
        </Button>
        <Button
          className={cn(classes.button)}
          size='small'
          color={tab === Tab.Pending ? 'primary' : 'default'}
          onClick={() => {
            setTab(Tab.Pending)
            dispatch(hitGTM(UI_ACCOUNT_PAGE_PENDING_INVITATION_FILTER))
          }}
        >
          {`Pending Invitation (${filteredList(originUsers, Tab.Pending).length})`}
        </Button>
      </div>
    )
  }
  function renderList() {
    const filtered = filteredList(originUsers, tab)
    const withFirstName = filtered.filter(item => item.firstName !== null)
    const withoutFirstName = filtered.filter(item => item.firstName === null)
    const list = [...withFirstName.sort(sortFunc), ...withoutFirstName]
    return (
      <List className={classes.root}>
        { list.map((user: UserAccount) => {
          const lastLoggedIn = helpers.lastLoggedIn(user.lastLogin)
          const getChipText = (userType: UserAccountUserType) => {
            return {
              [UserAccountUserType.Super]: `Super User`,
              [UserAccountUserType.Standard]: `Standard User`,
            }[userType]
          }
          const isMe = user.email === userProfile.email
          return (
          <div key={user.email} className={classes.listItemWrapper}>
            <Paper classes={{ root: classes.paperRoot }}>
              <ListItem alignItems='flex-start' className={classes.itemRoot}>
                <AccountCircleIcon className={cn(classes.userIcon, isMe && classes.userIconMe)} />
                <ListItemText
                  className={classes.listItemTextRoot}
                  primary={
                    <Typography className={cn(classes.ellipsis, classes.textRow)} color='textPrimary' component='span' data-mf-replace-inner={MFSDR} variant='body1'>
                      {user.firstName} {user.lastName}
                    </Typography>
                  }
                  secondary={
                    <React.Fragment>
                      <Typography className={cn(classes.ellipsis, classes.textRow)} color='textPrimary' component='span' data-mf-replace-inner={MFSDR} variant='body2'>
                        {user.email}
                      </Typography>
                      <Typography className={cn(classes.ellipsis, classes.textRow)} data-mf-replace-inner={MFSDR} variant='body2'>
                        {lastLoggedIn}
                      </Typography>
                    </React.Fragment>
                  }
                />
                <ListItemSecondaryAction>
                  { user.userType &&
                    <Chip
                      className={cn({
                        [classes.superUserChip]: user.userType === UserAccountUserType.Super,
                        [classes.standardUserChip]: user.userType === UserAccountUserType.Standard,
                      })}
                      label={getChipText(user.userType)}
                  /> }
                  <IconButton aria-label='Comments'
                    // edge='end'
                    onClick={(e) => handleClick(e, user)}>
                    <MoreVertIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            </Paper>
          </div>
          )
        })}
      </List>
    )
  }
  function filteredList(list: UserAccount[], tab: Tab) {
    if (tab === Tab.SuperUser) {
      return list.filter(user => user.userType === UserAccountUserType.Super)
    }
    if (tab === Tab.StandardUser) {
      return list.filter(user => user.userType === UserAccountUserType.Standard)
    }
    if (tab === Tab.Pending) {
      return list.filter(user => user.lastLogin === null)
    }
    return list
  }
  return (
    <div className={classes.rootWrapper}>
      { renderTabs() }
      { renderList() }
      {userInfoDialog}
      {selectedUser && (
        <Menu anchorEl={anchorEl} id="simple-menu" onClose={handleClose} open={Boolean(anchorEl)}>
          { selectedUser.lastLogin === null
            ? <MenuItem
              onClick={(e) => {
                dispatch(hitGTM(UI_RESEND_INVITATION_ACCOUNT_PAGE_RESEND_INVITATION_BTN))
                handleClose()
                setResendUserAccount(selectedUser)
                setResendOpen(true)
              }}
            >
              <ListItemIcon className={classes.icon}>
                <SendIcon />
              </ListItemIcon>
              <ListItemText classes={{ primary: classes.primary }} primary={`Resend Invitation`} />
            </MenuItem>
            : null
          }
          {selectedUser.userType !== `Super` ? (
            <MenuItem
              onClick={(e) => {
                handleClose()
                onUserTypeUpdate(selectedUser, accountId, false, accountName)
              }}
            >
              <ListItemIcon className={classes.icon}>
                <ArrowUpwardIcon />
              </ListItemIcon>
              <ListItemText classes={{ primary: classes.primary }} primary={`Upgrade to Super User`} />
            </MenuItem>
          ) : (
            <MenuItem
              onClick={(e) => {
                handleClose()
                onUserTypeUpdate(selectedUser, accountId, false, accountName)
              }}
            >
              <ListItemIcon className={classes.icon}>
                <ArrowDownwardIcon />
              </ListItemIcon>
              <ListItemText classes={{ primary: classes.primary }} primary={`Downgrade to Standard User`} />
            </MenuItem>
          )}
          <MenuItem
            onClick={(e) => {
              handleClose()
              onUserTypeUpdate(selectedUser, accountId, true)
            }}
          >
            <ListItemIcon className={classes.icon}>
              <RemoveCircleOutlineIcon />
            </ListItemIcon>
            <ListItemText classes={{ primary: classes.primary }} primary={`Remove from Account`} />
          </MenuItem>
        </Menu>
      )}
      <ResendConfirmModal
        classes={classes}
        open={resendOpen}
        userAccount={resendUserAccount}
        onClose={() => {
          setResendUserAccount(null)
          setResendOpen(false)
        }}
      />
    </div>
  )
}

const UsersList = compose<any, any>(
  withStyles(themeCreateInjectableStyles(usersListStyles) as any, { withTheme: true }),
)(UsersListComponent)

export default UsersList
